// Library for following an action through its lifecycle.
import PropTypes from 'prop-types';

export function incrementAction(stateData) {
  const actionState = stateData || { inProgress: 0 };
  return {
    ...stateData,
    inProgress: actionState.inProgress + 1,
    error: null,
  };
}

export function decrementAction(stateData, error) {
  const actionState = stateData || { inProgress: 0 };
  return {
    ...stateData,
    inProgress: Math.max(actionState.inProgress - 1, 0),
    error: error || null,
  };
}

export function actionInProgress(stateData) {
  return Boolean(stateData && stateData.inProgress && stateData.inProgress > 0);
}

export const actionPropType = PropTypes.shape({
  inProgress: PropTypes.number.isRequired,
  error: PropTypes.string,
});
